import './App.css';
import { Inicio } from './inicio/inicio';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Inventario } from './inventario/inventario';
import { ActivoRegistro } from './activoregistro/activoregistro';
import { ActivoVer } from './activover/activover';
import { Resumen } from './resumen/resumen';
import { Mantenimiento } from './mantenimiento/mantenimiento';

function App() {
  return (
    <Router>
      <header>
        <nav style={{
          background: '#0f172a',
          padding: '0.55rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
        }}>
          <span style={{
            color: 'rgba(255,255,255,0.4)',
            fontSize: '0.68rem',
            fontWeight: 700,
            letterSpacing: '0.13em',
            textTransform: 'uppercase',
          }}>
            <i className="bi bi-box-seam me-2" style={{ color: 'rgba(255,255,255,0.3)' }}></i>
            Sistema de Inventario
          </span>
        </nav>
      </header>

      <main className="container py-4">
        <Routes>
          <Route path="/activo" element={<Inicio/>} />
          <Route path="/activo/inventario" element={<Inventario/>} />
          <Route path="/activo/registro" element={<ActivoRegistro/>} />
          <Route path="/activo/ver" element={<ActivoVer/>} />
          <Route path="/activo/resumen" element={<Resumen/>} />
          <Route path="/activo/mantenimiento" element={<Mantenimiento/>} />
        </Routes>
      </main>

      <footer style={{
        background: '#0f172a',
        padding: '0.85rem 0',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.3)',
        fontSize: '0.72rem',
        letterSpacing: '0.02em',
      }}>
        <div className="container p-0">
          <a href="http://www.hagemsa.com" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', fontWeight: 700 }}>
            HAGEMSA
          </a>
          {' '}© 2008-{new Date().getFullYear()}
          <span style={{ margin: '0 0.5rem', opacity: 0.4 }}>·</span>
          v1.1
        </div>
      </footer>
    </Router>
  );
}

export default App;
